/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Fr3_HeadingInputs */

const en_funnel_sq_fr3_heading = /** @type {(inputs: Funnel_Sq_Fr3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any source, and capture as you go.`)
};

const es_funnel_sq_fr3_heading = /** @type {(inputs: Funnel_Sq_Fr3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cualquier fuente, y toma notas sobre la marcha.`)
};

/**
* | output |
* | --- |
* | "Any source, and capture as you go." |
*
* @param {Funnel_Sq_Fr3_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_fr3_heading = /** @type {((inputs?: Funnel_Sq_Fr3_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Fr3_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_fr3_heading(inputs)
	return en_funnel_sq_fr3_heading(inputs)
});